import { state } from '@angular/animations';
import { Component, OnInit } from "@angular/core";
import { merge, Observable, of as observableOf, Subscription } from "rxjs";
import {
  startWith,
  switchMap,
  map,
  catchError,
  finalize,
} from "rxjs/operators";
import { DashboardDirectionJuridiqueService } from "src/app/new-dashboard/core/service/dashboard-direction-juridique.service";
import { PageDashboardDossierCredit } from 'src/app/new-dashboard/core/model/PageDashboardDossierCredit';
import { NewDashboardParticulierService } from 'src/app/new-dashboard/core/service/new-dashboard-particulier.service';
import { NewDashboardWorkflowService } from "src/app/new-dashboard/core/service/new-dashboard-workflow.service";

@Component({
  selector: "app-particulier-dossiers-list",
  templateUrl: "./dossiers-list.component.html",
  styleUrls: ["./dossiers-list.component.scss"]
})
export class DossiersListComponent implements OnInit {
  isLoading$: Observable<boolean>;
  tab: string = "";
  label: string = "";
  subscription!: Subscription;
  //Loader par cardView
  isLoading: boolean = false;
  pageSize: number = 10; // Number of items to display per page
  pageIndex: number = 0; // Number of
  paginatedItems: PageDashboardDossierCredit;
  filter: string;
  codeWorkflow: string = "PARTICULIER";
  state: String = "_";

  constructor(
    private _dashboardWorkflowService: NewDashboardWorkflowService) {}

  ngOnInit() {
  //  this.getDossiersCreditStatus("", 0);
        this.getDossiersCreditWorkflowStatus("", this.state, 0);

  }

     filterByState(): void {
    this.getDossiersCreditWorkflowStatus("", this.state, 0);
  }


    getDossiersCreditWorkflowStatus(filter: string,state:String, page: number): void {
    merge()
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoading = true;
          const actualFilter = filter !== undefined ? filter : "";
          return this._dashboardWorkflowService.getDossiersWorkflowByStatus(
            this.codeWorkflow,
             state,
            actualFilter,
            page,
            this.pageSize
          );
        }),
        map((data: PageDashboardDossierCredit) => {
          return data;
        }),
        catchError(() => observableOf(null)),
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe(data => {
        this.paginatedItems = data;
      });
  }




  goToPage(page: number) {
    if (page >= 0) {
      this.pageIndex = page;
            this.getDossiersCreditWorkflowStatus(this.filter, this.state,  this.pageIndex);

    }
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filter = filterValue.trim().toLowerCase();
    this.pageIndex = 0; // Number of
            this.getDossiersCreditWorkflowStatus(this.filter, this.state,  this.pageIndex);
  }
  pageSizeChanged() {
    this.pageIndex = 0; // Number of

            this.getDossiersCreditWorkflowStatus(this.filter, this.state,  this.pageIndex);
  }
}
